"use client";
import { usePathname } from "next/navigation";
import { schemaConfig } from "../lib/MetaConfig";
import Script from "next/script";

export default function Schema() {
  const pagePath = usePathname();
  const pageSchema = schemaConfig[pagePath];

  return (
    <>
      {pageSchema && (
        <Script
         
          type="application/ld+json"
          strategy="beforeInteractive">
          {JSON.stringify(pageSchema)}
        </Script>
      )}
    </>
  );
}
